export default __webpack_public_path__ + "static/media/gallery-slideout.c2f2fc44.jpg";